import {
  type GraphQLNamedType,
  isEnumType,
  isInputObjectType,
  isInterfaceType,
  isObjectType,
  isScalarType,
  isUnionType,
} from 'graphql';
import { useParams } from 'react-router';

import { OopsPage } from '#src/App/OopsPage.tsx';

import { schema } from '../schema.ts';
import { useSchemaHashParams } from '../useSchemaHashParams.ts';

import { EnumSchemaPage } from './EnumSchemaPage.tsx';
import { InputObjectSchemaPage } from './InputObjectSchemaPage.tsx';
import { InterfaceSchemaPage } from './InterfaceSchemaPage.tsx';
import { ObjectSchemaPage } from './ObjectSchemaPage.tsx';
import { ScalarSchemaPage } from './ScalarSchemaPage.tsx';
import { UnionSchemaPage } from './UnionSchemaPage.tsx';

const TypeSchemaPage = ({
  namedType,
  fieldName,
}: {
  namedType: GraphQLNamedType;
  fieldName?: string;
}) => {
  if (isObjectType(namedType)) {
    return <ObjectSchemaPage objectType={namedType} fieldName={fieldName} />;
  } else if (isInputObjectType(namedType)) {
    return (
      <InputObjectSchemaPage
        inputObjectType={namedType}
        fieldName={fieldName}
      />
    );
  } else if (isInterfaceType(namedType)) {
    return (
      <InterfaceSchemaPage interfaceType={namedType} fieldName={fieldName} />
    );
  } else if (isScalarType(namedType)) {
    return <ScalarSchemaPage scalarType={namedType} />;
  } else if (isEnumType(namedType)) {
    return <EnumSchemaPage enumType={namedType} />;
  } else if (isUnionType(namedType)) {
    return <UnionSchemaPage unionType={namedType} />;
  }

  return namedType satisfies never;
};

export const NamedTypePage = () => {
  const { typeName } = useParams();
  const { fieldName } = useSchemaHashParams();

  const namedType = schema.getType(typeName ?? '');
  if (!namedType) {
    return <OopsPage />;
  }

  return (
    <TypeSchemaPage
      key={namedType.name}
      namedType={namedType}
      fieldName={fieldName}
    />
  );
};
